import { useHomeownerAppContext } from 'src/modules/homeownerApp/hooks';
import {
  usePartner,
  usePartnerOrgId,
} from 'src/modules/homeownerApp/hooks/usePartner/index';

/**
 * Returns true if the current user is a homeowner and the current context has
 * no partner
 */
export const useIsHomeownerWithoutPartner = (): {
  isLoading: boolean;
  isHomeownerWithoutPartner?: boolean;
} => {
  const { isLoading } = usePartner();
  const { user } = useHomeownerAppContext();
  const partnerOrgId = usePartnerOrgId();

  // If a user does not exist, the user is considered a homeowner
  if (user && !user.isHomeowner) {
    return { isLoading: false, isHomeownerWithoutPartner: false };
  }

  if (isLoading) {
    return { isLoading };
  }

  return { isLoading: false, isHomeownerWithoutPartner: !partnerOrgId };
};
